import { h } from 'preact';
import { useState } from 'preact/hooks';
import { IconCheckmark } from './icon-checkmark';
import { t } from '../theme/locales';
export const CreateNewList = function({ name , onNameChange , onSubmit , disabled  }) {
    const [inputVisible, setInputVisible] = useState(false);
    return h('form', {
        className: 'wishlist__create-new-list',
        onSubmit: (e)=>onSubmit(e)
    }, [
        h('label', {
            className: 'flex items-center',
            htmlFor: 'wishlist-create-new-list-checkbox',
            role: 'button',
            tabindex: '0',
            onKeyDown: (e)=>{
                if (e.key === 'Enter' || e.code === 'Space') {
                    e.preventDefault();
                    setInputVisible(!inputVisible);
                }
            }
        }, [
            h('div', {
                className: 'flex'
            }, [
                h('input', {
                    type: 'checkbox',
                    id: 'wishlist-create-new-list-checkbox',
                    name: 'wishlist-create-new-list-checkbox',
                    className: 'wishlist__add-to-list-checkbox wishlist__add-to-list-checkbox--hidden wishlist__content__title',
                    checked: inputVisible,
                    onChange: (event)=>setInputVisible(event.currentTarget.checked)
                }),
                h('span', {
                    className: 'wishlist__add-to-list-visual'
                }, [
                    h(IconCheckmark, {})
                ]),
                h('p', {
                    className: 'wishlist__content__title margin-left'
                }, t('wishlist.create_new_list_prompt'))
            ])
        ]),
        inputVisible && h('input', {
            id: 'wishlist-name',
            name: 'wishlist-name',
            type: 'text',
            value: name || '',
            placeholder: t('wishlist.create_new_list_placeholder'),
            'aria-label': t('wishlist.create_new_list_prompt'),
            onInput: (event)=>onNameChange(event.currentTarget.value)
        }),
        h('button', {
            type: 'submit',
            disabled: disabled,
            className: 'wishlist__content__action alt'
        }, t('wishlist.add_to_list'))
    ]);
};
